export default "__VITE_ASSET__ClTHdUuN__";